import { FC } from 'react';
import { logEvent } from '@/containers/AnalyticsContainer';
import { useChatData } from '@/containers/ChatContainer';
import { TColor } from '@mofid-securities/uikit';
import { Icon } from '@/components/atomic/Icon';
import { useGetRouteStoryData } from '@/components/Hint';
import PulseBadge from '@/components/PulseBadge/PulseBadge';
import { classnames } from '@/utils/classnames';

interface ITopMenuIconProps {
  className?: string;
  onClick: () => void;
  color?: TColor | `#${string}` | undefined;
}

const TopMenuIcon: FC<ITopMenuIconProps> = ({
  className,
  onClick,
  color = 'green-30',
}) => {
  const { totalUnread } = useChatData();
  const { analyticsEvent } = useGetRouteStoryData();

  return (
    <button
      aria-label="راهنما"
      className={classnames(
        'relative flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded-xl bg-white',
        className
      )}
      onClick={() => {
        if (analyticsEvent) {
          logEvent(analyticsEvent, null);
        } else {
          logEvent('Story_click_open');
        }
        onClick();
      }}
    >
      {!!totalUnread && <PulseBadge className="absolute right-0 top-0" />}
      <Icon color={color} icon="question_outline" size={28} />
    </button>
  );
};

export default TopMenuIcon;
